import {z} from "../../../../../lib";
import {schemaEntityWithId, schemaEntityWithIdAndDescription, schemaSelectionOption} from "../../../../../types";

export enum EventoFields {
    Fecha = 'fecha',
    IdOrigen = 'idOrigen',
    BigIdOrigen = 'bigIdOrigen',
    DescTabla = 'descTabla',
    Observaciones = 'observaciones',
    BigIdOrigenRelacionado = 'bigIdOrigenRelacionado',
    IdOrigenRelacionado = 'idOrigenRelacionado',
    IdUsuario = 'idUsuario',
    DescUsuario = 'descUsuario',
    DescEventoTipo = 'descEventoTipo',
    CodEventoTipo = 'codEventoTipo'
}

export const schemaEventoVistaDTO = z
    .object({
        [EventoFields.Fecha]: z.coerce.date(),
        [EventoFields.IdOrigen]: z.number(),
        [EventoFields.BigIdOrigen]: z.number(),
        [EventoFields.DescTabla]: z.string(),
        [EventoFields.Observaciones]: z.string(),
        [EventoFields.BigIdOrigenRelacionado]: z.number().nullable(),
        [EventoFields.IdOrigenRelacionado]: z.number().nullable(),
        [EventoFields.IdUsuario]: z.number(),
        [EventoFields.DescUsuario]: z.string(),
        [EventoFields.DescEventoTipo]: z.string(),
        [EventoFields.CodEventoTipo]: z.number(),
    })
    .merge(schemaEntityWithId)

export type EventoVistaDTO = z.infer<typeof schemaEventoVistaDTO>

export enum EventoRequestFields {
    FechaDesde = 'fechaDesde',
    FechaHasta = 'fechaHasta'
}

export const schemaEventoRequestDTO = z.object({
    [EventoFields.CodEventoTipo]: z.number().optional(),
    [EventoRequestFields.FechaDesde]: z.date().optional(),
    [EventoRequestFields.FechaHasta]: z.date().optional()
})

export type EventoRequestDTO = z.infer<typeof schemaEventoRequestDTO>


const schemaFiltroEventos = z.object({
    [EventoFields.CodEventoTipo]: schemaSelectionOption.optional(),
    [EventoRequestFields.FechaDesde]: z.date().optional(),
    [EventoRequestFields.FechaHasta]: z.date().optional()
})

export type SchemaFiltroEventos = z.infer<typeof schemaFiltroEventos>


export enum EventoTipoFields {
    EventoOperacion = 'eventoOperacion',
    EventoSeguridad = 'eventoSeguridad',
    EventoWF = 'eventoWF'
}

export const schemaEventoTipo = z
    .object({
        [EventoTipoFields.EventoOperacion]: z.boolean(),
        [EventoTipoFields.EventoSeguridad]: z.boolean(),
        [EventoTipoFields.EventoWF]: z.boolean()
    })
    .merge(schemaEntityWithIdAndDescription)

export type EventoTipo = z.infer<typeof schemaEventoTipo>